import { EFinancingProgram } from '@if/core/types'
import * as yup from '@if/core/yup'

const copyOptionsSchemaObject = {
  copyMessages: yup.boolean().required().default(true),
  copyDocuments: yup.boolean().required().default(true),
  copyCoapplicant: yup.boolean().required().default(true),
}

export const copyAsDraftOptionsSchema = yup.object(copyOptionsSchemaObject)

export const copyAsDraftSchema = yup.object({
  financingProgramId: yup.mixed<EFinancingProgram>().required(),
  merchantId: yup.text().required(),
  ...copyOptionsSchemaObject,
})

export type CopyAsDraftForm = yup.InferSubmit<typeof copyAsDraftSchema>
